import { createContext } from 'react';
import { DialogManagerReturn, ScopedDialogMethods } from '@shared/hooks/useDialogManager';

export interface WebsiteEditorDialogContextValue
  extends Readonly<{
    dialogManager: DialogManagerReturn;
    getScopedMethods: (dialogId: string) => ScopedDialogMethods;
  }> {}

export const WebsiteEditorDialogContext = createContext<WebsiteEditorDialogContextValue | null>(null);

export interface WebsiteEditorDialogProviderProps
  extends Readonly<{
    children: React.ReactNode;
    componentDialogPriorities?: readonly (readonly string[])[];
  }> {}
